import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Delete, DragIndicatorRounded } from '@mui/icons-material'
import { IconButton, Paper, Stack, Tooltip } from '@mui/material'
import { EditorStep } from './schemaEditorReducer'

interface P {
    step: EditorStep
    isSelected: boolean
    onSelect: (id: string) => void
    onDelete: (id: string) => void
}

const SortableStepItem = ({ step, isSelected, onSelect, onDelete }: P) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: step._id,
        disabled: step.isDefault
    })

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    }

    return (
        <Paper
            ref={setNodeRef}
            onClick={() => onSelect(step._id)}
            sx={{
                'cursor': 'pointer',
                'p': 2,
                'bgcolor': isSelected
                    ? 'primary.focusVisible'
                    : 'background.paper',
                '&:hover': {
                    bgcolor: !isSelected
                        ? 'primary.focus'
                        : 'primary.focusVisible'
                }

            }}
            style={style}>
            <Stack
                spacing={1}
                direction='row'
                alignItems='center'>

                <Stack
                    {...attributes}
                    {...listeners}
                    sx={{ cursor: step.isDefault ? 'default' : 'grab' }}>
                    <DragIndicatorRounded color={step.isDefault ? 'disabled' : 'inherit'} />
                </Stack>

                <Stack
                    style={{ flex: 1 }}>
                    {step.label}
                </Stack>

                <Stack>

                    <Tooltip title={step.isDefault ? 'Default Steps can\'t be deleted' : 'Delete'} arrow>
                        <span>
                            <IconButton
                                color='error'
                                disabled={step.isDefault}
                                onClick={e => {
                                    e.stopPropagation()
                                    onDelete(step._id)
                                }}>
                                <Delete />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Stack>
            </Stack>
        </Paper>
    )
}

export default SortableStepItem
